<template>
  <div class="ware">
    <div class="wareHead" style="position: relative;">
      <div
        class="mack"
        :height="bannerHeight+'px'"
        style="
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: black;
          opacity: 0.4;
        "
      ></div>
      <div :height="bannerHeight+'px'">
      <img
      ref="bannerHeight"
      @load="imgLoad"
      style="display: block;width: 100%;height: 100%;"
      :src="banner"
      alt=""
      />
      </div>
      <div class="aside">
        <p class="title">{{ name }}</p>
        <p class="desc">
          {{ desc }}
        </p>
      </div>
    </div>
    <div class="wrapper">
      <div class="more">
        <ul>
          <li
            class="list"
            v-for="(item, index) in list"
            :key="index"
            @click="getData(index)"
          >
            <img :src="item.img" alt=""/>
            <div class="bottom">
              <p>{{ item.name }}</p> 
              <span  ><i class="el-icon-d-arrow-right" ></i>产品详情</span>
            </div>
          </li>
          <el-dialog :title="dataName" :visible.sync="dialogTableVisible2" >
            <div class="griddesc" >
              <span>
                详情：
              </span> 
              <div >{{dataDesc}}</div>
            </div>
          </el-dialog>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { baseUrl } from "../api/index";
export default {
  data() {
    return {
      // banner: "",
      list: [],
      d: "date",
      dialogTableVisible1: false,
      dialogTableVisible2: false,
      i: "",
      gridData: [],
      dataDesc:"",
      dataName: "",
      imgParams:"",
      bannerHeight: "",
    };
  },
  computed: {
    ...mapState("solution",["banner","name","desc"]),
  },
  created() {
    this.getProductInfo({ cid: this.$route.params.id });
  },
  mounted() {
    this.imgLoad();
    window.addEventListener(
      "resize",
      () => {
        this.imgLoad();
      },
      false
    );
  },
  watch: {
    $route: function (to, from) {
      if (to != from) {
        this.getProductInfo({ cid: this.$route.params.id });
      }
    },
  },
  methods: {
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
      });
    },
    getData(index) {
      this.dialogTableVisible2 = true;
      this.i = index;
      this.dataDesc=this.list[this.i].desc
      this.dataName = this.list[this.i].name;
    },
    bigImg(img){
      this.dialogTableVisible1 = true;
      this.imgParams=img
    },
    async getProductInfo(params) {
      let res = await this.$api.getProductInfo(params);
      this.list = res.data.data;
      this.list.forEach((ele) => {
        ele.img = baseUrl + ele.img;
        let arr=JSON.parse(ele.info)
        arr.forEach((item,index)=>{
          if(item.title==""||item.content==""){
          arr.splice(index, 1)  
          }
        })
        this.gridData.push(arr);
      });
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 1200px) {
  /deep/.el-dialog{
    width: 75% !important;
  }
  .griddesc{
    font-size: 20px;
    text-align: left;
    div{
      font-size: 16px;
      line-height: 30px;
      padding: 10px 18px;
    }

  }
  .gridparams{
    margin-top: 20px;
    font-size: 20px;
    text-align: left;
    .par {
    padding: 10px;
    border-bottom: 1px solid #eee;
    display: flex;
    .title {
      margin-right: 10px;
      text-align: left;
      font-size: 18px;
      font-weight: 300;
      line-height: 30px;
      min-width: 12%;
    }
    .content {
      padding-left: 10px;
      line-height: 30px;
      font-size: 16px;
    }
  }

  }

table.gridtable {
    font-family: verdana,arial,sans-serif;
    font-size:11px;
    color:#333333;
    border-width: 1px;
    border-color: #666666;
    border-collapse: collapse;
}
table.gridtable th {
    border-width: 1px;
    padding: 18px;
    border-style: solid;
    border-color: #666666;
    background-color: #dedede;
}
table.gridtable td {
    border-width: 1px;
    padding: 15px;
    border-style: solid;
    border-color: #666666;
    background-color: #ffffff;
}
.ware {
  .wareHead {
    position: relative;
    width: 100%;
    // height: 4.6rem;
    .aside {
        position: absolute;
        top: 0.5rem;
        left: 0.2rem;
        padding: 10px 150px 10px 10px;
        color: aliceblue;
        .title {
          font-size: 0.45rem;
          padding-bottom: 0.2rem;
        }
        .desc {
          // width: 4rem;
          font-size: 0.2rem;
          margin-right: 0;
          line-height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
        }
      }
    img {
      width: 100%;
      height: 100%;
    }
    .show {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-size: 0.5rem;
    }
  }
  .wrapper {
    text-align: center;
    width: 12rem;
    margin: 0 auto;
    color: rgb(227, 233, 238);
    margin-top: 0.8rem;
    .more {
      font-size: 0.3rem;
      ul {
        display: flex;
        flex-wrap: wrap;
        .list {
          cursor: pointer;
          position: relative;
          width: 3.5rem;
          height: 3.5rem;
          margin-right: 0.75rem;
          margin-bottom: 0.75rem;
          border-radius: 0.1rem;
          overflow: hidden;
          box-shadow: 10px 10px 10px 0px rgb(0 0 0 / 6%);
          transition: all 0.5s;
          &:hover {
            box-shadow: 0 2px 25px rgba(150, 150, 150, 0.5);
            transform: translateY(-5px);
          }
          img {
            width: 100%;
            height: 2.7rem;
            image-rendering: pixelated;
          }
          .bottom {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 0.8rem;
              line-height: 0.8rem;
              color: black;
              background-color: #fff;
              font-size: 18px;
              display: flex;
              justify-content: space-between;
              p{
                // background-color: pink;
                margin: 0 auto;
                width: 216px;
                white-space:nowrap;
                overflow:hidden;
                text-overflow:ellipsis;
              }
              span {
                width: 28%;
                font-size: 14px;
                color: #388fff;
                // margin-left: 40px;
              }
            }
        }
        li:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
}

}



@media screen and (max-width: 750px) {
  /deep/.el-dialog{
    width: 75%;
  }
  /deep/.el-dialog__header {
    padding: 0.1rem 0.05rem;
  }
  /deep/.el-dialog__title {
    line-height: 0.15rem;
    font-size: 0.16rem;
  }
  /deep/.el-dialog__body{
    padding: 0.05rem 0.2rem;
  }
  .griddesc{
    font-size: 0.12rem;
    text-align: left;
    span{
      display: inline-block;
      margin-bottom: 0.05rem;
    }
    div{
      font-size: 0.1rem;
      line-height: 0.14rem;
      padding: 0.03rem 0.06rem;
    }

  }
  .gridparams{
    margin-top: 0.1rem;
    font-size: 0.12rem;
    text-align: left;
    span{
      display: inline-block;
      margin-bottom: 0.05rem;
    }
    .par {
      padding: 0.03rem;
      border-bottom: 1px solid #eee;
      display: flex;
      .title {
        margin-right: 0.1rem;
        text-align: left;
        font-size: 0.1rem;
        font-weight: 300;
        line-height: 0.1rem;
        min-width: 20%;
      }
      .content {
        padding-left: 0.1rem;
        line-height: 0.13rem;
        font-size: 0.1rem;
      }
    }

  }

  .ware {
    min-height: 5rem;
    .wareHead {
      position: relative;
      width: 100%;
      // height: 1.5rem;
      .aside{
        position: absolute;
        top: 0.1rem;
        left: 0.05rem;
        padding: 0.03rem 0.3rem 0.1rem 0.1rem;
        color: aliceblue;
        .title {
          font-size: 0.12rem;
          padding-bottom: 0.05rem;
        }
        .desc {
          font-size: 0.08rem;
          margin-right: 0;
          line-height: 0.10rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
      .show {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
        font-size: 0.2rem;
      }
    }
    .wrapper {
      text-align: center;
      width: 3.2rem;
      margin: 0 auto;
      color: rgb(227, 233, 238);
      margin-top: 0.2rem;
      .more {
        font-size: 0.3rem;
        ul {
          display: flex;
          flex-wrap: wrap;
          .list {
            cursor: pointer;
            position: relative;
            width: 1rem;
            height: 1rem;
            margin-right: 0.1rem;
            margin-bottom: 0.15rem;
            border-radius: 0.1rem;
            overflow: hidden;
            box-shadow: 10px 10px 10px 0px rgba(0, 0, 0, 0.06);
            transition: all 0.5s;
            &:hover {
              box-shadow: 0 2px 25px rgba(150, 150, 150, 0.5);
              transform: translateY(-5px);
            }
            img {
              width: 100%;
              height:0.7rem;
            }
            .bottom {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 0.3rem;
              line-height: 0.3rem;
              color: black;
              background-color: #fff;
              font-size: 0.05rem;
              display: flex;
              justify-content: space-between;
              p{
                // background-color: pink;
                margin: 0 auto;
                width: 0.7rem;
                white-space:nowrap;
                overflow:hidden;
                text-overflow:ellipsis;
              }
              span {
                width: 15%;
                font-size: 0.04rem;
                color: #388fff;
                margin-right: 0.04rem;
                line-height: 0.31rem;
                // margin-left: 40px;
              }
            }
          }
          li:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>